export default __webpack_public_path__ + "images/stripe-payment-element/visa-a8709002496dcfe90d2c317e9166e0e0.svg";